import { render, staticRenderFns } from "./BulkDiscount.vue?vue&type=template&id=6ee01696"
import script from "./BulkDiscount.vue?vue&type=script&lang=js"
export * from "./BulkDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports